<div [hidden]="! isLoading" class="text-xs-center">
  <h2><i class="fa fa-cog fa-spin fa-lg"></i> Henter data</h2>
</div>